
















































































































































































































import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";
import TekananDarah from "@/components/pemeriksaan/assesmen/TekananDarah.vue";
import FrekuensiNadi from "@/components/pemeriksaan/assesmen/FrekuensiNadi.vue";
import FrekuensiNafas from "@/components/pemeriksaan/assesmen/FrekuensiNafas.vue";
import SuhuBadan from "@/components/pemeriksaan/assesmen/SuhuBadan.vue";
import SaturasiOksigen from "@/components/pemeriksaan/assesmen/SaturasiOksigen.vue";
import KeadaanUmum from "@/components/pemeriksaan/assesmen/KeadaanUmum.vue";
import Kesadaran from "@/components/pemeriksaan/assesmen/Kesadaran.vue";
import TimeStamp from "@/components/pemeriksaan/assesmen/TimeStamp.vue";
import { userModule } from "@/store/modules/user";
import { storeAssesmenRalan } from "@/store/modules/asesmenralan";
import { appModule } from "@/store/modules/app";
// import CardRiwayatTandaVital from "@/components/pemeriksaan/assesmen/CardRiwayatTandaVital.vue";

@Component({
  components: {
    TekananDarah,
    FrekuensiNadi,
    FrekuensiNafas,
    SuhuBadan,
    SaturasiOksigen,
    KeadaanUmum,
    Kesadaran,
    TimeStamp,
    // CardRiwayatTandaVital
  },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class TandaVital extends Vue {
  @Prop() register!: string;
  @Prop() rm!: string;
  @Prop() showBtn!: boolean;
  @Prop() showRiwayat!: boolean;
  @Prop() tv!: object;

  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  // sistole = 0;
  // diastole = 0;
  // nadi = 0;
  // nafas = 0;
  // suhu = 0;
  // oksigen = 0;
  // keadaan = "";
  // kesadaran = "";
  // time = "";
  // tandaVital = {};
  time = new Date()
    .toLocaleString("en-CA", { hour12: false, timeZone: "Asia/Jakarta" })
    .toString()
    .substr(12, 8);
  maxDate = new Date().toISOString().substr(0, 10);
  today = new Date().toISOString().substr(0, 10);
  // waktu_periksa: today + " " + time

  setTd(val) {
    // this.sistole = val[0];
    // this.diastole = val[1];
    this.tandaVital["sistole"] = val[0];
    this.tandaVital["diastole"] = val[1];
  }
  setFrekNadi(val) {
    // this.nadi = val;
    this.tandaVital["frekuensi_nadi"] = val;
  }
  setFrekNafas(val) {
    // this.nafas = val;
    this.tandaVital["frekuensi_nafas"] = val;
  }
  setSuhu(val) {
    // this.suhu = val;
    this.tandaVital["suhu_badan"] = val;
  }
  setSatOksigen(val) {
    // this.oksigen = val;
    this.tandaVital["saturasi_oksigen"] = val;
  }
  setKu(val) {
    // this.oksigen = val;
    this.tandaVital["keadaan_umum"] = val;
  }
  setKesadaran(val) {
    this.tandaVital["kesadaran"] = val;
  }
  setTime(val) {
    // this.time = val;
    this.tandaVital["waktu_periksa"] = val;
  }
  // setIdTandaVital(id) {
  //   storeTandaVital.actTandaVital_on_id(id);
  //   // this.tandaVital = this.stateDetaiTandaVital;
  //   // console.log(this.stateDetaiTandaVital);
  // }

  // get stateDetailTandaVital() {
  //   return storeTandaVital.detailTandaVital;
  // }

  // get stateTandaVital() {
  //   return storeTandaVital.tandaVital[0];
  // }

  get stateuser() {
    return userModule.user;
  }
  get stateAsesmenAwal() {
    return storeAssesmenRalan.asesmenAwal;
  }

  get tandaVital() {
    return this.tv;
  }
  // set tandaVital(val) {
  //   this.$emit("tandaVital", val);
  // }
  @Watch("tandaVital")
  changeTandaVital(v) {
    // console.log("tandaVital", v);
    this.$emit("tandaVital", v);
  }

  mounted() {}
}
